module.exports = __webpack_public_path__ + "img/14.bdb381e4.jpg";